import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ParamService } from 'src/app/_services/parc-service/param-service/param-service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-type-vehicule-auto',
  templateUrl: './add-type-vehicule-auto.component.html',
  styleUrls: ['./add-type-vehicule-auto.component.scss']
})
export class AddTypeVehiculeAutoComponent implements OnInit {


  typevehiculeForm: FormGroup;
  isSubmitted: boolean = false;
  isLoading = false;
  isMaterial: boolean = false;
  constructor(

    private translate: TranslateService,
    private http: HttpClient,
    private paramService: ParamService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private ref: MatDialog

  ) { }

  ngOnInit(): void {

    // initialisation de type vehicule
      this.inittypevehicule();
      this.isMaterial = '/setting/forms/type-vehicule/add' != location.pathname;
  }



  public inittypevehicule() {
    this.typevehiculeForm = this.formBuilder.group({
      description: [''],
      name: ['', Validators.required],
    });
  }


  get typevehiculeform() {
    return this.typevehiculeForm.controls;
  }


  onSubmitTypeVehicule() {
    this.isSubmitted = true;
    this.isLoading = false;
    if (this.typevehiculeForm.invalid) {
      this.toastrService.error('ERREUR', 'Les champs en rouge sont obligatoires!');
      return;
    }
    this.isLoading = true;
    const formData = new FormData();
    formData.append('description', '' + this.typevehiculeform.description.value);
    formData.append('name', '' + this.typevehiculeform.name.value);
    formData.append('code', '' + 'TYPE_VEHICULE');
    this.paramService.addForm(formData)
      .then(resp => {
        this.toastrService.success('ajouter avec succes!', 'Succes!');
        this.typevehiculeForm.reset();
        this.typevehiculeForm = this.formBuilder.group({
          description: [''],
          name: ['', Validators.required],
        });
        this.isSubmitted = false;
      })
      .catch(err => {
        console.log(err)
        this.toastrService.error('Veuillez vérifier votre serveur ou Ce type de véhicule existe déjà', 'error!');
      })
      .finally(() => this.isLoading = false);
  }


  close() {
    this.ref.closeAll();
    // location.reload();
  }
}












